module.exports = __webpack_public_path__ + "img/mail_logo.3833e2d4.png";